import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import apiRequest from '@/js/helpers/apiRequest';

async function get() {
  const { DATA: { LOCATIONS, REGIONS } } = await apiRequest.get('/location/popular/');

  return {
    locations: LOCATIONS.map(city => ({
      name: city.NAME,
      location: city.CODE,
    })),
    regions: map(REGIONS, group => mapValues(group, letter => letter.map(city => ({
      name: city.NAME,
      location: city.CODE,
    })))),
  };
}

export default { get };
